<adapt-toolbar-title>
    <h3>
        <i class="fal fa-fw fa-list me-2"></i> Search Results
        @if (isValidQuery) {
            @if (searchResults && !isLoading) {
                <span class="ms-1">({{ resultCount }})</span>
            }
            @if (isLoading) {
                <span class="ms-1">(...)</span>
            }
        }
    </h3>
</adapt-toolbar-title>

<div class="m-2">
    <div class="row">
        @if (isValidQuery) {
            <h4 class="align-items-center d-flex">
                Showing results for
                @if (searchKeyword) {
                    <b class="ms-1">"{{ searchKeyword }}".</b>
                }
                @if (searchService.searchLabels$ | async; as labels) {
                    <adapt-display-labels class="ms-2"
                                          [labels]="labels"
                                          [linkDisabled]="true"></adapt-display-labels>
                }
            </h4>
            <div class="search-options mb-3">
                @if (!options?.activeOnly) {
                    <span>Showing inactive results. </span>
                }
                @if (options?.personId; as personId) {
                    <span>Relating to <adapt-link-person [personId]="personId"></adapt-link-person>. </span>
                }
                @if (options?.teamId; as teamId) {
                    <span>Within group <adapt-link-team [teamId]="teamId"
                                                        [showLabels]="false"></adapt-link-team>. </span>
                }
                @if (options?.updatedSince; as since) {
                    <span>Updated within {{ since.text }}.</span>
                }
                @if (slowLoadingIndicator) {
                    <div class="alert alert-info my-2 py-1">Search is taking a while to return results. Please wait...</div>
                }
            </div>
            @if (searchResults && resultCount === 0 && !isLoading) {
                <div class="alert alert-info">No results found.</div>
            }
            <div class="col"
                 [ngClass]="{
                    'col-lg-8': isLoading && showImplementationKitResults && hasNonSupportResults,
                }">
                @for (group of searchResultGroups | keyvalue: null; track trackByResultGroup($index, group)) {
                    @if (group.value && group.key; as category) {
                        <div class="mb-4">
                            <h4 class="mb-2 text-dark"
                                data-test="search-result-group">
                                <i [class]="category.icon + ' me-1'"></i>
                                {{ category.name }}
                            </h4>
                            @for (error of getErrors(category.type); track error) {
                                <div class="alert alert-danger">
                                    {{ error }}
                                </div>
                            }
                            <div [ngClass]="{
                                    'border-start ps-3 ms-2 category-subgroup': !!category.subGroups,
                                }">
                                @if (!category.subGroups) {
                                    <ng-container [ngTemplateOutlet]="searchComponent"
                                                  [ngTemplateOutletContext]="{
                                            $implicit: searchResults,
                                        }"></ng-container>
                                } @else {
                                    @for (subGroup of searchResultSubgroups.get(category.type) | keyvalue: null; track trackByResultSubGroup($index, subGroup)) {
                                        <div class="mb-3">
                                            <h5 class="mb-2 text-dark">
                                                <i [class]="subGroup.key.icon + ' me-1'"></i>
                                                {{ subGroup.key.name }}
                                            </h5>
                                            <ng-container [ngTemplateOutlet]="searchComponent"
                                                          [ngTemplateOutletContext]="{
                                                    $implicit: subGroup.value,
                                                }"></ng-container>
                                        </div>
                                    }
                                }
                                <ng-template #searchComponent
                                             let-results>
                                    <adapt-render-component [component]="searchElements!.component"
                                                            [componentInputs]="{
                                            type: category.type,
                                            searchResults: results,
                                        }">
                                    </adapt-render-component>
                                </ng-template>
                            </div>
                        </div>
                    }
                }
                <div *adaptLoading="isLoading"></div>
            </div>
            @if (showImplementationKitResults) {
                <div class="col-12"
                     [ngClass]="{
                        'col-lg-4': hasNonSupportResults || isLoading,
                    }">
                    @if (SearchTypeMapping[SearchType.ImplementationKit]; as group) {
                        <div>
                            <h4 class="mb-2">
                                <i [class]="group.icon + ' me-1'"></i>
                                {{ group.name }}
                            </h4>
                            @for (error of getErrors(SearchType.ImplementationKit); track error) {
                                <div class="alert alert-danger">
                                    {{ error }}
                                </div>
                            }
                            <div class="implementation-kit-container p-3">
                                <div *adaptLoading="isLoading">
                                    @for (result of searchResults?.ImplementationKit; track result) {
                                        <adapt-search-row-implementation-kit [result]="result"></adapt-search-row-implementation-kit>
                                    }
                                </div>
                            </div>
                        </div>
                    }
                </div>
            }
        } @else {
            <h4 class="mt-3 mb-4">No search keyword or labels provided.</h4>
        }
    </div>
</div>
